import { Fragment } from 'react';

import { Container, Text } from '@/atoms';
import { Faq } from '@/molecules';

/**
 * Faqs
 */
// TODO(Sergio): Hay dos componentes distintos de faqs, hay que intentar juntarlos en uno solo. Consultar con Guille
const Faqs = ({ bloque, id, className = '' }: any) => (
  <Container id={id} wrapper className={`mx-auto max-w-[610px] ${className}`}>
    {bloque.faq.map((faq: any, index: number) => (
      <Fragment key={index}>
        <Text
          as={faq.headingType}
          className="u-headline u-headline--h2 mb-6 text-center text-primary-900"
        >
          {faq.title}
        </Text>

        {faq.preguntas.map((pregunta: any, index: number) => (
          <Faq
            key={index}
            className="mb-4"
            question={pregunta.question}
            headingType={pregunta.headingType}
          >
            {pregunta.answer}
          </Faq>
        ))}
      </Fragment>
    ))}
  </Container>
);

Faqs.displayName = 'Faqs';

export default Faqs;
